import type { FaireBrandEntity } from "../../entity_types/brand";

export const west_clay_company: FaireBrandEntity = {
  token: "west-clay-company",
  type: "brand",
  name: "West Clay Company",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 89,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
